import { render, staticRenderFns } from "./category-panel.vue?vue&type=template&id=7009d4a7&"
import script from "./category-panel.vue.ts?vue&type=script&lang=ts&"
export * from "./category-panel.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports